// @ts-nocheck
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { onboardingQuestionnaireActions } from '../../../../../../store';
import { getSerializedErrorMessage } from '../../../../../../utils/errors';

import type { AppDispatch } from '../../../../../../store';
import type { IOnboardingQuestionnaireDocument } from '../../../../../../pages/questionnaires/onboarding/types';

export function useOnboardingQuestionnaireDocuments(
  onboardingQuestionnaireId: string | undefined,
) {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const [documents, setDocuments] = useState<IOnboardingQuestionnaireDocument[]>([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);

  useEffect(() => {
    if (!onboardingQuestionnaireId) {
      setDocuments([]);
      setDocumentsLoading(false);
      return;
    }

    let cancelled = false;
    setDocuments([]);
    setDocumentsLoading(true);

    const request = dispatch(
      onboardingQuestionnaireActions.getOnboardingQuestionnaireDocuments({
        onboardingQuestionnaireId,
        getAccessTokenSilently,
      }),
    );

    request.then((result) => {
      if (cancelled) return;

      if (
        onboardingQuestionnaireActions.getOnboardingQuestionnaireDocuments.fulfilled.match(result)
      ) {
        setDocuments(result.payload);
      } else if (
        onboardingQuestionnaireActions.getOnboardingQuestionnaireDocuments.rejected.match(result) &&
        !result.meta.aborted
      ) {
        toast.error(getSerializedErrorMessage(result.error));
      }
      setDocumentsLoading(false);
    });

    return () => {
      cancelled = true;
      request.abort();
    };
  }, [dispatch, getAccessTokenSilently, onboardingQuestionnaireId]);

  return {
    documents,
    documentsLoading,
    setDocuments,
  };
}
